<template>
  <div class="cart-item">
    <price-modal
      :max_quantity="product.max_quantity"
      :productId="product.product_id"
      :stock="product.stock"
      :productQuantity="parseInt(product.quantity, 10)"
      :index="index"
      @quantityChanged="quantityChanged($event)"
    >
    </price-modal>
    <div class="cart-grid">
      <div class="cart-contents-wrapper">
        <div class="description">
          <router-link
            class="cart-product-title"
            tag="p"
            :to="{name: 'ProductDetails',
                  query:{
                    productName: product.product_name,
                    productId: product.product_id
                    }
                  }"
            :id="'cart-pdt-image-'+product.product_id"
												data-test="cartProductNameLink"
          >
            {{product.product_name}}
          </router-link>
          <!--<small class="options">Size: <span>M</span></small>-->
          <small class="seller" data-test="cartProductSellerName"
																	id="cartProductSellerName">
            Seller:
            <span data-test="cartProductSellerNameSpan"
																		id="cartProductSellerNameSpan">{{product.vendor_name}}</span>
          </small>
        </div>
        <div
          class="pricy"
          v-if="product.promotion_id"
        >
          <span data-test="cartProductPromotionSpan"
																id="cartProductPromotionSpan">
            {{product.promotion_applied_price | currencyConversion}}
          </span>
          <span data-test="cartProductPromotionPdtPriceSpan"
																id="cartProductPromotionPdtPriceSpan">
            {{product.price | currencyConversion}}
          </span>
          <span data-test="cartProductPromotionPdtPercntSpan"
																id="cartProductPromotionPdtPercntSpan">
            {{product.discount_percentage}}% off
          </span>
        </div>

        <div
          class="pricy"
          v-if="!product.promotion_id"
        >
          <span data-test="cartProductPdtPriceSpan"
																id="cartProductPdtPriceSpan">
            {{product.price | currencyConversion}}
          </span>
          <!--<span>50% off</span>-->
        </div>
        <!--<p class="itemleft">Hurry, Only 5 left!</p>-->
        <div class="cart-button-block">
          <a
            type="a"
            name
            id="save-later-cart-btn"
            class="btn cart_btn_remove_save_wishlist"
            v-if="$route.path !== '/order-success'"
            @click.prevent="cartAddToWishlist(product.product_id)"
												data-test="cartProductSaveToWishlistLink"
												style="white-space: nowrap; cursor: pointer"
          >
            <i class="fas fa-cart-arrow-down" data-test="cartProductSaveToWishlistLinkI"
															id="cartProductSaveToWishlistLinkI"></i>
            Save to Wishlist
          </a>
          <a
            type="a"
            name
            id="remove-cart-btn"
            class="btn cart_btn_remove_save_wishlist"
            v-if="$route.path !== '/order-success'"
            @click.prevent="removeProduct(product.product_id)"
            :style="(product.stock < 1 || product.product_id === null) ?
             'color: #2874f0;': ''"
												data-test="cartProductRemoveLink"
												style="cursor: pointer"
          >
            <i class="fas fa-trash" data-test="cartProductRemoveLinkI"
															id="cartProductRemoveLinkI"></i>
            Remove
          </a>
        </div>
      </div>
      <div class="cart-image-warpper">
        <out-of-stock v-if="!(product.stock && product.stock > 0)">
        </out-of-stock>
        <img
          class="cart-product-image"
          :src="product.image_url"
          alt
										data-test="cartProductImg"
										id="cartProductImg"
        >
        <product-quantity-changer
          :product="product"
          :index="index"
          :disabled="disabled"
        >
        </product-quantity-changer>
      </div>
    </div>
    <!--<div class="cart-grid" v-if="$route.path === '/order-success'">-->
    <!--<div style="-->
    <!--margin-top: 1rem;-->
    <!--">-->
    <!--Delivery within 8 Days-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="cart-grid" v-if="$route.path === '/order-success'">-->
    <!--<div style="margin-top: 1rem;">-->
    <!--<div>-->
    <!--<button class="btn blue-btn">Cancel Item</button>-->
    <!--</div>-->
    <!--<div style="margin-top: 10px;">-->
    <!--Need Help-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<ul class="deliver">-->
    <!--<li>-->
    <!--<p>Delivery by, Fri May 17 |
    <span class="deliv-offer">Free</span>
    <span class="deliv-price">$40</span>-->
    <!--</p>-->
    <!--</li>-->
    <!--</ul>-->
  </div>
</template>

<script>
import PriceModal from '@/components/pages/cart/modals/PriceModal'
import OutOfStock from '@/components/widgets/outofstock/OutOfStock'
import ProductQuantityChanger from
	'@/components/pages/cart/cartContainer/cartProductList/cartProduct/widgets/ProductQuantityChanger'
import { mapActions, mapGetters } from 'vuex'
import { customerApi } from '../../../../../../services/ApiServices/customerApi'
import { sharedCartMethods } from '../../../../../../commonJs/sharedCartMethods'

export default {
	components: {
		OutOfStock,
		PriceModal,
		ProductQuantityChanger
	},
	computed: {
		...mapGetters('user', ['isAuthenticated']),
		...mapGetters('buynow', ['getBuyNowProductCount']),
		...mapGetters('cart', ['getCartCount'])
	},
	methods: {
		...mapActions('cart', ['deleteFromCart']),
		...mapActions('wishlist', ['addToWishlist']),
		...mapActions('buynow', ['deleteFromBuyNow']),
		cartAddToWishlist (productId) {
			if (this.isAuthenticated) {
				this.$toasted.show('Saved to Wishlist')
				this.addToWishlist(productId)
				this.updateWishList()
				this.deleteProduct(productId)
				this.$forceUpdate()
			} else {
				this.deleteProduct(productId)
				this.$router.push({
					path: '/login',
					query: {
						next_to: 'wishList',
						product_id: productId
					}
				})
			}
		},
		quantityChanged (quantity) {
			this.product.quantity = quantity
		},
		updateWishList () {
			customerApi.insertWishList()
				.then((res) => {

				})
				.catch((e) => {

				})
		},
		removeProduct (productId) {
			this.$dialog
				.confirm('Are you sure you want to remove this item?')
				.then((dialog) => {
					this.deleteProduct(productId)
					this.$toasted.show('Successfully removed the product from the cart', {
						icon: 'exclamation-circle',
						position: 'bottom-center'
					})
				})
				.catch(() => {
					// console.log('Clicked on cancel')
				})
		},
		deleteProduct (product) {
			if (this.getBuyNowProductCount > 0) {
				this.deleteFromBuyNow()
				this.$router.push({
					path: '/cart',
					query: {
						display_text: 'My Cart'
					}
				})
			} else {
				this.deleteFromCart(product)
				sharedCartMethods.insertCartApiChooser()
				if ((this.getCartCount < 1) &&
          (this.$route.path === '/checkout')) {
					this.$router.push('/cart')
				}
			}
		}
	},
	props: {
		product: {},
		index: {
			default: 0,
			type: Number
		},
		disabled: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<!--<style scoped>-->
<!--.cart-grid {-->
<!--width: 60%;-->
<!--}-->
<!--</style>-->
